import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    sendPasscode: function (passcode, serial, agencyId) {
        var params = {
            passcode: passcode,
            code: serial,
            agencyId: agencyId,
            device_app_id: this.config().client_id
        }
        var url = `${this.config().bzbsModuleWallet}/merchant/redeem_passcode`;
        return BzbsApi.connectBzbsPost(url, null, params);
    }
}
